/**
 * Leitura das respostas de erro da API.
 *
 * O servidor já explica o que houve, inclusive qual permissão faltou. Trocar
 * essa explicação por um "Erro ao carregar veículos" joga fora a única
 * informação útil: a pessoa fica sem saber se o sistema caiu, se a internet
 * falhou ou se ela simplesmente não tem acesso àquilo.
 */

export interface ErroDePermissao {
  codigo: 'sem_permissao';
  modulo: string;
  acao: string;
  message: string;
}

/** O erro é uma negativa de permissão, e não uma falha do sistema? */
export const ehSemPermissao = (erro: any): boolean =>
  erro?.response?.status === 403 && erro?.response?.data?.codigo === 'sem_permissao';

/** O erro é a senha provisória ainda não trocada? */
export const ehSenhaProvisoria = (erro: any): boolean =>
  erro?.response?.data?.codigo === 'senha_provisoria';

/**
 * Mensagem para mostrar ao usuário.
 *
 * Prefere sempre o que o servidor disse. A alternativa entra só quando não há
 * resposta nenhuma, o que normalmente significa rede fora do ar.
 */
export const mensagemDoErro = (erro: any, alternativa: string): string => {
  // Sem erro nenhum não há o que interpretar: quem chamou já sabe o que dizer.
  // A guarda de tela usa este caminho, e sem ele caía no aviso de rede abaixo,
  // dizendo "sem conexão" para um bloqueio de permissão.
  if (!erro) return alternativa;

  const dados = erro?.response?.data;

  if (dados?.message) return dados.message;

  // Erro de validação sem mensagem geral: mostra o primeiro campo recusado.
  const primeiroCampo = dados?.errors && (Object.values(dados.errors).flat()[0] as string);
  if (primeiroCampo) return primeiroCampo;

  if (erro?.response?.status === 404) return 'Registro não encontrado.';
  if (!erro?.response) return 'Sem conexão com o servidor. Verifique a internet e tente de novo.';

  return alternativa;
};
